import { Link } from 'react-router-dom';
import { t } from '@/lib/i18n';
import styles from './UsedByLinks.module.css';

interface AgentRef {
  id: string;
  name: string;
}

interface JobRef {
  id: string;
  title: string;
}

interface UsedByLinksProps {
  agents: AgentRef[];
  jobs: JobRef[];
  /** Singular vs plural copy ("Position" vs "Unit") for empty states. */
  kindLabel: string;
}

/**
 * Reverse-lookup sections shown on Position / Unit detail pages: Staff
 * Profiles and Job Templates whose defaults reference this item. Each entry
 * is a navigation link into the relevant detail page.
 */
export function UsedByLinks({ agents, jobs, kindLabel }: UsedByLinksProps) {
  return (
    <div className={styles.wrap}>
      <section className={styles.section}>
        <h3 className={styles.heading}>
          {t('Member Profiles defaulting to this {kind}', { kind: kindLabel })}
        </h3>
        {agents.length === 0 ? (
          <p className={styles.empty}>{t('None.')}</p>
        ) : (
          <div className={styles.chips}>
            {agents.map((a) => (
              <Link
                key={a.id}
                to={`/library/member-profiles/${encodeURIComponent(a.id)}`}
                className={styles.chip}
              >
                {a.name}
              </Link>
            ))}
          </div>
        )}
      </section>

      <section className={styles.section}>
        <h3 className={styles.heading}>
          {t('Job Profiles targeting this {kind}', { kind: kindLabel })}
        </h3>
        {jobs.length === 0 ? (
          <p className={styles.empty}>{t('None.')}</p>
        ) : (
          <div className={styles.chips}>
            {jobs.map((j) => (
              <Link
                key={j.id}
                to={`/library/job-profiles/${encodeURIComponent(j.id)}`}
                className={styles.chip}
              >
                {j.title}
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
